export default __webpack_public_path__ + "static/media/dinnerFasting.3f063d53.svg";